// React
import React, { useState, useMemo } from "react";
import Moment from "moment";
// Lodash
import { map, uniqBy } from "lodash";
// PropTypes
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";
import Resumidas from "./Components/SummaryTable";
import Detalladas from "./Components/DetailedTable";
import ForHoursAgentTable from "./Components/ForHoursAgentTable";
import ForHoursGroupsTable from "./Components/ForHoursGroupsTable";
import ForDaysTable from "./Components/ForDaysTable";
import ForHoursTable from "./Components/ForHoursTable";
import MensajeUsuariosTable from "./Components/MensajeUsuariosTable";

// Utils
import dataHandler from "@Utils/dataHandler";
import ActionUserCrud from "./Modals/ActionUserCrud";
// Styles
import styles from "./styles.module.css";

const TableActionUser = ({ dispatch, userName, companyName, channels }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [platformfilters, setPlatformfilters] = useState([]);
	const [groupsfilters, setGroupsfilters] = useState([]);
	const [tagsSelected, setTagsSelected] = useState([]);
	const [categoriesSelected, setCategoriesSelected] = useState([]);
	const [startDate, setStartDate] = useState(Moment().format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState("");
	const [contacts, setContacts] = useState("");
	const [agents, setAgents] = useState([]);
	const [note, setNote] = useState("");
	const [checkAlllData, setCheckAllData] = useState([]);
	const [dateField, setDateField] = useState("closeDate");
	const [showTable, setShowTable] = useState(false);
	const [channelFilters, setChannelFilters] = useState([]);
	const [isOpenModal, setIsOpenModal] = useState(true);
	const [tableValue, setTableValue] = useState({});
	const [seletedFilteres, setSeletedFilteres] = useState("");
	const [appliedFilters, setAppliedFilters] = useState({});
	const [stateValue, setStateValue] = useState("");
	const [orderBy, setOrderBy] = useState("");
	const [orderDirection, setOrderDirection] = useState("");
	const [tabValue, setTabValue] = useState("");

	const [selectedFields, setSelectedFields] = useState([]);
	const [listItemsSelected, setListItemsSelected] = useState([]);

	const options = [
		{ key: "Detalladas", text: "Detalladas", value: "Detalladas" },
		{ key: "Resumidas", text: "Resumidas", value: "Resumidas" },
		{ key: "Por Horas", text: "Por Horas", value: "Por Horas" },
		{ key: "Por Dias", text: "Por Días", value: "Por Días" },
		{ key: "Hora/Usuarios", text: "Hora/Usuarios", value: "Hora/Usuarios" },
		{ key: "Hora/Grupos", text: "Hora/Grupos", value: "Hora/Grupos" },
		// { key: "Mensaje/Usuarios", text: "Mensaje/Usuarios", value: "Mensaje/Usuarios" },
	];

	const platforms = useMemo(() => {
		return uniqBy(
			map(channels, (item) => {
				return item.platform;
			}),
			"name"
		);
	}, [channels]);

	// Table handlers
	const handlerData = async (params, printable, findAll, isCheck = false) => {
		const data = await dataHandler({ dispatch, url: "chats", params });
		if (!isCheck && !printable) {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setTableValue(data.items);
		}
		if (printable) {
			setFilteredPrintData(data.items);
		}

		if (findAll) {
			setCheckAllData(data.items);
		} else {
			setCheckAllData([]);
		}
	};

	// // Table Handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				setIsOpenModal(true);
				setTableValue(item);
				break;
			default:
				break;
		}
	};

	const handleFilterData = () => {
		setIsOpenModal(true);
	};

	const renderTopButtons = () => {
		return [
			{
				icon: "filter",
				className: styles.refreshButton,
				onClick: handleFilterData,
				content: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
				label: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
			},
		];
	};

	const handleApplyFilters = (filters) => {
		setShowTable(true);
		setAppliedFilters(filters);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle={`Reporte Cerrada${seletedFilteres ? ` - ${seletedFilteres}` : ""}`}>
			{!seletedFilteres && (
				<div className={styles.grid}>
					<IkTable
						data={filteredItems}
						handlerTable={handleButtom}
						totalRows={filteredCount}
						dataHandler={handlerData}
						filteredPrintData={filteredPrintData}
						searcher={{
							searchable: false,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						topButtons={renderTopButtons()}
						checkAllData={checkAlllData}
					/>
				</div>
			)}
			{seletedFilteres === "Detalladas" && showTable && (
				<Detalladas
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
					selectedFields={selectedFields}
					listItemsSelected={listItemsSelected}
				/>
			)}
			{seletedFilteres === "Hora/Usuarios" && showTable && (
				<ForHoursAgentTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Hora/Grupos" && showTable && (
				<ForHoursGroupsTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Resumidas" && showTable && (
				<Resumidas
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Por Días" && showTable && (
				<ForDaysTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Por Horas" && showTable && (
				<ForHoursTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Mensaje/Usuarios" && showTable && (
				<MensajeUsuariosTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{isOpenModal && (
				<ActionUserCrud
					companyName={companyName}
					userName={userName}
					tableValue={tableValue}
					onClose={() => {
						setIsOpenModal(false);
					}}
					agents={agents}
					contacts={contacts}
					startDate={startDate}
					endDate={endDate}
					note={note}
					platformfilters={platformfilters}
					groupsfilters={groupsfilters}
					tagsSelected={tagsSelected}
					setAgents={setAgents}
					setContacts={setContacts}
					setStartDate={setStartDate}
					setEndDate={setEndDate}
					setNote={setNote}
					setPlatformfilters={setPlatformfilters}
					setGroupsfilters={setGroupsfilters}
					setTagsSelected={setTagsSelected}
					categoriesSelected={categoriesSelected}
					setCategoriesSelected={setCategoriesSelected}
					seletedFilteres={seletedFilteres}
					options={options}
					setSeletedFilteres={setSeletedFilteres}
					dateField={dateField}
					setDateField={setDateField}
					onApplyFilters={handleApplyFilters}
					platforms={platforms}
					channelFilters={channelFilters}
					setChannelFilters={setChannelFilters}
					tabValue={tabValue}
					setTabValue={setTabValue}
					stateValue={stateValue}
					setStateValue={setStateValue}
					orderBy={orderBy}
					setOrderBy={setOrderBy}
					orderDirection={orderDirection}
					setOrderDirection={setOrderDirection}
					selectedFields={selectedFields}
					setSelectedFields={setSelectedFields}
					listItemsSelected={listItemsSelected}
					setListItemsSelected={setListItemsSelected}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		channels: company.channels,
	};
}

TableActionUser.propTypes = {
	dispatch: PropTypes.func,
	userName: PropTypes.string,
	companyName: PropTypes.string,
	channels: PropTypes.array,
};

export default connect(mapStateToProps)(TableActionUser);
